import {useState, useCallback} from 'react';
import {translations} from 'presentation/translations-new';
import {UsePermissionState, UsePermissions} from './types';

const {serverError, permissionsNotAllowed} = translations['pt-br'].commons;

export const usePermissions = ({permissionName}: UsePermissions) => {
	const [permissionState, setPermissionState] = useState<UsePermissionState>({
		permission: null,
		error: null,
	});

	const checkPermission = useCallback(async () => {
		if (!navigator.permissions) {
			setPermissionState({
				permission: null,
				error: permissionsNotAllowed,
			});
			return;
		}
		try {
			const resp = await navigator.permissions.query({name: permissionName});
			setPermissionState(prev => ({
				...prev,
				permission: resp.state,
				error: null,
			}));
			resp.onchange = () => {
				setPermissionState(prev => ({
					...prev,
					permission: resp.state,
					error: null,
				}));
			};
		} catch (error) {
			setPermissionState({
				permission: null,
				error: (error as Error)?.message ?? serverError,
			});
		}
	}, []);

	return {...permissionState, checkPermission};
};
